import validator from '@/constant/valitator';
import postCheckEmailStatus from '@/fetches/user/auth/post-check-email-status';
import { actions } from '@/store';
import { EAuthModalPage } from '@/store/types';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Message from '@/constant/message';
import { useDispatch } from 'react-redux';
import { AnchorText } from '../common/anchor-text';
import { AuthButton } from '../common/auth-button';
import { AuthTitle } from '../common/auth-title';
import { InputText } from '../common/input-text';

/** (소셜 이메일 없을경우) 이메일 입력 */
export const InputEmailSocial: React.FC = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onChangeEmailInput = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget;
    setEmail(value);
    setError('');
  }, []);

  const submitEmailSocial = useCallback(async () => {
    const emailErr = validator.checkEmail(email);
    if (emailErr) {
      setError(t(emailErr));
      return;
    }
    setLoading(true);
    const result = await postCheckEmailStatus(email);
    switch (result) {
      case 'email does not exist':
        dispatch(actions.user.authModal.setCurrentPage(EAuthModalPage.SEND_EMAIL_AND_INPUT_CONFIRM_CODE));
        dispatch(actions.user.authModal.setEmail(email));
        break;
      case 'email exists with password':
      case 'email exists without password':
        setError(t(Message.이미사용중인이메일입니다다른이메일을입력하세요));
        break;
      case 'not email format':
        setError(t(Message.올바른이메일이아닙니다));
        break;
      case 'error':
        setError(t(Message.처리도중서버에서오류가발생했습니다잠시후다시시도하시거나관리자에게문의해주세요));
        break;
      default:
    }
    setLoading(false);
  }, [dispatch, email, t]);

  return (
    <>
      <AuthTitle>{t(Message.추가이메일인증)}</AuthTitle>
      <AnchorText>
        {t(Message.사용하실계정의최초이메일인증이필요합니다)}
        <br />
        {t(Message.이메일을입력하세요)}
      </AnchorText>
      <InputText
        type="email"
        title={t(Message.이메일을입력하세요)}
        errorText={error}
        value={email}
        disabled={loading}
        autoFocus
        onPressEnter={submitEmailSocial}
        onChange={onChangeEmailInput}
        autoComplete="email"
      />
      <AuthButton type="button" onClick={submitEmailSocial}>{t(Message.다음)}</AuthButton>
    </>
  );
};
